<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障期間</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障期間-1 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-1"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="7"
        />
        <label class="hide-label" for="insuranceTime-1"></label>
        <span class="ml-50 lh-40">繳費期間</span>
      </div>

      <!-- 保障期間-2 -->
      <div class="radio radio-inline mb-15">
        <input
          type="radio"
          id="insuranceTime-5"
          :class="{ 'is-invalid': validate.isPeriodTypeErr }"
          v-model="form.periodType"
          value="1"
        />
        <label class="hide-label" for="insuranceTime-5"></label>
        <span class="lh-40 ml-50">第</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isBeginErr }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model.number="form.begin"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isBeginUnitErr }"
          v-model="form.beginUnit"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">到</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isEndErr }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.end"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isEndUnitErr }"
          v-model="form.endUnit"
        >
          <option
            v-for="item in pageControl.coveragePeriodUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">之後</span>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePagePeriod",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {
          pageName: "",
          coveragePeriodUnits: [],
        };
      },
    },
    form: {
      type: Object,
      default: () => {
        return {
          periodType: 1,
          begin: 1,
          beginUnit: 1,
          end: 110,
          endUnit: 2,
        };
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {
          isPeriodTypeErr: false,
          isBeginErr: false,
          isBeginUnitErr: false,
          isEndErr: false,
          isEndUnitErr: false,
        };
      },
    },
  },
  watch: {
    "form.periodType"(value) {
      if (value == 7) {
        this.form.beginCondition = 1;
      } else {
        this.form.beginCondition = 0;
      }
    },
  },
};
</script>
